import React from 'react';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import PasswordChangeForm from '../../components/PasswordChangeForm';

const PasswordChange = () => {
  return (
    <div>
      <DashboardLayout title="Mudar senha">
        <ReducedContent>
          <PasswordChangeForm showTitle={false} columnWidth="6" />
        </ReducedContent>
      </DashboardLayout>
    </div>
  );
};

export default PasswordChange;
